package ui.pages

import web.cssom.ident

object Area {
    val Header = ident("header")
    val Sidebar = ident("sidebar")
    val Content = ident("content")
    val Footer = ident("footer")
    val Spacer = ident("spacer")
    val SpacerBottom = ident("spacer_bottom")


    object MainScreenCmp {
        val head = ident("main_screen_cmp_head")
        val error = ident("main_screen_cmp_error")
        val main = ident("main_screen_cmp_main")
    }

    object HeaderBox {
        val left = ident("header_box_left")
        val center = ident("header_box_center")
        val right = ident("header_box_right")
    }

    object FooterBox {
        val left = ident("footer_box_left")
        val center = ident("footer_box_center")
        val right = ident("footer_box_right")
    }

    object ScheduleBox{
        val title = ident("schedule_box_title")
        val scheduleMain = ident("schedule_box_schedule_main")
        val selectedInfo = ident("schedule_box_selected_info")
        val confirmButton = ident("schedule_box_confirm_button")
    }

    object DrawerBox{
        val drawerTitle = ident("drawer_box_title")
        val drawerTop = ident("drawer_box_top")
        val drawerBottom = ident("drawer_box_bottom")
    }
}